var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9858 11.7406L21.9864 17.0217C21.9864 18.4842 20.8447 19.6801 19.4039 19.7667L19.2364 19.7717H4.75853C3.296 19.7717 2.10013 18.63 2.01355 17.1892L2.00853 17.0217L2.00781 11.7406H21.9858ZM18.2504 15.2459H15.7504L15.6486 15.2527C15.2825 15.3024 15.0004 15.6162 15.0004 15.9959C15.0004 16.3756 15.2825 16.6894 15.6486 16.739L15.7504 16.7459H18.2504L18.3522 16.739C18.7182 16.6894 19.0004 16.3756 19.0004 15.9959C19.0004 15.6162 18.7182 15.3024 18.3522 15.2527L18.2504 15.2459ZM19.2364 5.7666C20.6989 5.7666 21.8948 6.90831 21.9813 8.34908L21.9864 8.5166L21.9858 10.2406H2.00781L2.00853 8.5166C2.00853 7.05407 3.15024 5.8582 4.59101 5.77162L4.75853 5.7666H19.2364Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSmall);
export default __webpack_public_path__ + "static/media/wallet-small.3d8468043f73203fdc9a360645f3b09b.svg";
export { ForwardRef as ReactComponent };